import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
  {
    path: '*',
    redirect: '/home'
  },
  {
    path:'/home',
    name: 'home',
    component: () => import('../view/home'),
    meta: {
      title: '银豹合作伙伴学堂'
    }
  },
  {
    path:'/login',
    name: 'login',
    component: () => import('../view/login'),
    meta: {
      title: '登录'
    }
  },
  {
    path:'/member',
    name: 'member',
    component: () => import('../view/member'),
    meta: {
      title: '会员'
    }
  },
  {
    path:'/history',
    name: 'history',
    component: () => import('../view/history'),
    meta: {
      title: '历史记录'
    }
  },
  {
    path:'/collect',
    name: 'collect',
    component: () => import('../view/collect'),
    meta: {
      title: '收藏'
    }
  },
  {
    path:'/compulsory',
    name: 'compulsory',
    component: () => import('../view/compulsory'),
    meta: {
      title: '必修课程'
    }
  },
  {
    path: '/password',
    name: 'password',
    component: () => import('../view/password'),
    meta: {
      title: '修改密码'
    }
  },
  {
    path:'/compulsory/:id',
    name: 'compulsoryDetail',
    component: () => import('../view/compulsoryDetail'),
  },
  {
    path:'/notice',
    name: 'notice',
    component: () => import('../view/notice'),
    meta: {
      title: '公告'
    }
  },
  {
    path:'/noticeDetail/:id',
    name: 'noticeDetail',
    component: () => import('../view/noticeDetail'),
    meta: {
      title: '公告详情'
    }
  },
  {
    path:'/course/:id',
    name: 'course',
    component: () => import('../view/course'),
    meta: {
      title: '课程目录'
    }
  },
  {
    path:'/course/details/:id',
    name: 'courseDetails',
    redirect: '/course/:id'
  },
  {
    path:'/player/:courseId/:id',
    name: 'player',
    component: () => import('../view/player'),
    meta: {
      title: '播放'
    }
  },
  {
    path:'/topic',
    name: 'topic',
    component: () => import('../view/topic'),
    meta: {
      title: '专题'
    }
  },
  {
    path:'/thematic',
    name: 'thematic',
    redirect: '/topic'
  },
  {
    path:'/topicDetail/:id',
    name: 'topicDetail',
    component: () => import('../view/topicDetail'),
    meta: {
      title: '专题明细'
    }
  },
  {
    path:'/thematic/details/:id',
    name: 'thematicDetails',
    redirect: '/topicDetail/:id'
  }
];

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

const router = new Router({ routes });

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

export {
  router
};